import { Summary } from 'src/components/molecules/Summary';
import { RoutingRuleType } from 'src/graphql';

interface Props {
  orderedRules: Omit<RoutingRuleType, 'Author'>[];
}

export const RoutingSummary = ({ orderedRules }: Props) => {
  const totalRules = orderedRules.filter((rule) => rule.createdAt).length;
  const totalActiveRules = orderedRules.filter(
    (rule) => rule.createdAt && !rule.disabled,
  ).length;
  const pausedRules = orderedRules.filter(
    (rule) => rule.createdAt && rule.disabled,
  ).length;
  const routedGroups = [
    ...new Set(
      orderedRules
        .filter((rule) => rule.createdAt && rule.destinationGroup)
        .map((rule) => rule.destinationGroup),
    ),
  ].length;
  const itemTotals = [
    { title: 'Total rules created', value: totalRules },
    { title: 'Total rules active', value: totalActiveRules },
    { title: 'Rules paused', value: pausedRules },
    { title: 'Routed groups', value: routedGroups },
  ];
  return <Summary itemTotals={itemTotals} />;
};
